import React from "react";

// Isometric security illustration in Northstar navy + amber
const SecurityIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 560 480" className={className} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Security systems illustration">
    <defs>
      <linearGradient id="s-plat" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#E7EBF1" />
        <stop offset="1" stopColor="#C4CDDB" />
      </linearGradient>
      <linearGradient id="s-shield" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#D2AB66" />
        <stop offset="1" stopColor="#806326" />
      </linearGradient>
      <linearGradient id="s-amber" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#D2AB66" />
        <stop offset="1" stopColor="#C39A54" />
      </linearGradient>
      <radialGradient id="s-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0" stopColor="#C39A54" stopOpacity="0.42" />
        <stop offset="1" stopColor="#C39A54" stopOpacity="0" />
      </radialGradient>
    </defs>

    <ellipse cx="280" cy="250" rx="260" ry="200" fill="url(#s-glow)" />

    <polygon points="280,150 500,270 280,390 60,270" fill="url(#s-plat)" opacity="0.95" />
    <polygon points="280,390 60,270 60,300 280,420" fill="#A9B6CB" />
    <polygon points="280,390 500,270 500,300 280,420" fill="#92A2BC" />

    <g>
      <polygon points="140,265 190,294 140,323 90,294" fill="#DFE6F0" />
      <polygon points="140,323 90,294 90,314 140,343" fill="#BCC8DC" />
      <polygon points="140,323 190,294 190,314 140,343" fill="#A6B4CB" />
    </g>

    <polygon points="280,180 400,246 280,312 160,246" fill="#FFFFFF" />
    <polygon points="280,312 160,246 160,268 280,334" fill="#D7DFEC" />
    <polygon points="280,312 400,246 400,268 280,334" fill="#BFCADD" />

    {/* shield */}
    <g transform="translate(280,120)">
      <path d="M0,0 L46,18 V70 C46,104 24,126 0,140 C-24,126 -46,104 -46,70 V18 Z" fill="url(#s-shield)" />
      <path d="M-18,66 L-4,82 L22,50" stroke="#142744" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </g>

    {/* camera */}
    <g transform="translate(150,150)">
      <polygon points="0,0 44,26 0,52 -44,26" fill="#DFE6F0" />
      <rect x="-14" y="-30" width="30" height="16" rx="6" fill="#C39A54" transform="skewX(-30)" />
      <circle cx="6" cy="-16" r="6" fill="#142744" />
    </g>

    {/* lock */}
    <g transform="translate(410,190)">
      <polygon points="0,0 44,26 0,52 -44,26" fill="url(#s-amber)" />
      <rect x="-14" y="-24" width="28" height="22" rx="4" fill="#142744" />
      <path d="M-8,-24 V-32 a8,8 0 0 1 16,0 V-24" stroke="#142744" strokeWidth="4" fill="none" />
      <circle cx="0" cy="-13" r="3.5" fill="#C39A54" />
    </g>

    {/* access panel */}
    <g transform="translate(370,300)">
      <polygon points="0,0 40,24 0,48 -40,24" fill="#E7EBF1" />
      <rect x="-16" y="8" width="30" height="10" rx="3" fill="#C39A54" transform="skewX(-30)" />
    </g>

    {/* fingerprint */}
    <g transform="translate(190,310)">
      <polygon points="0,0 40,24 0,48 -40,24" fill="#142744" />
      <g stroke="#C39A54" strokeWidth="2.5" fill="none" opacity="0.95" transform="translate(0,24) scale(1,0.6)">
        <circle r="6" />
        <circle r="11" />
        <circle r="16" />
      </g>
    </g>
  </svg>
);

export default SecurityIllustration;
